import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { setImpersonation } from '@/features/impersonation/model/storage';
import { exchangeCode } from './exchange.api';

export function ImpersonationExchangePage() {
  const [params] = useSearchParams();
  const code = params.get('code') ?? '';
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setError('Код не передан');
      return;
    }
    let cancelled = false;

    (async () => {
      try {
        const r = await exchangeCode(code);
        if (cancelled) return;
        setImpersonation({
          token: r.token,
          impersonationId: r.impersonationId,
          clientName: r.clientName,
        });
        // Replace history so the back button doesn't return to the exchange URL
        // (the code is already consumed and would show "не найдено").
        navigate('/', { replace: true });
        // Hard reload so axios instances pick up the new Bearer header injected
        // by the existing impersonation interceptor, and Centrifugo re-subscribes
        // to the impersonated account channel.
        window.location.reload();
      } catch (e: unknown) {
        if (cancelled) return;
        const status = (e as { response?: { status?: number } })?.response?.status;
        if (status === 404) {
          setError('Код не найден или уже использован');
        } else if (status === 410) {
          setError('Срок действия кода истёк (30 секунд). Откройте сессию заново из admin UI.');
        } else {
          setError('Ошибка обмена. Закройте вкладку и попробуйте снова из admin UI.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  if (error) {
    return (
      <Box sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>Не удалось войти</Typography>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ p: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
      <CircularProgress size={20} />
      <Typography>Соединение с кабинетом клиента…</Typography>
    </Box>
  );
}
